import { API } from "aws-amplify";
import { getTenant, getUser } from "~/graphql/queries";
import { LoaderData } from "~/types";
import * as APITypes from "~/API";

export const EMPTY_USER_INFO: APITypes.User = {
  __typename: "User",
  id: "",
  createdAt: "",
  updatedAt: "",
  roles: APITypes.ManagerRolesType.MaintenanceStaff,
  _version: 0,
  _lastChangedAt: 0,
};

export const getUserInfo = async ({
  userID,
}: {
  userID?: string;
}): Promise<LoaderData<APITypes.User>> => {
  try {
    const response = (await API.graphql({
      query: getUser,
      variables: {
        id: userID,
      },
    })) as { data?: APITypes.GetUserQuery };

    return {
      success: true,
      data: response.data?.getUser || EMPTY_USER_INFO,
    };
  } catch (error) {
    return {
      success: false,
      data: EMPTY_USER_INFO,
      error,
    };
  }
};
